module.exports = __webpack_public_path__ + "img/31.e4129421.jpg";